var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDescriptiveLocationPin = function SvgDescriptiveLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M12 21.8c-.4 0-.8-.1-1.1-.4-2.2-1.9-7.1-6.7-7.1-11.4 0-4.3 3.7-7.8 8.2-7.8 4.5 0 8.2 3.5 8.2 7.8 0 4.7-5 9.5-7.1 11.3-.3.3-.7.5-1.1.5m0-18.1c-3.7 0-6.8 2.8-6.8 6.2 0 4.1 5 8.8 6.6 10.2.1.1.2.1.3 0 1.5-1.3 6.6-6 6.6-10.2.1-3.3-3-6.2-6.7-6.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M12 13.6c-1.8 0-3.2-1.5-3.2-3.2 0-1.7 1.5-3.2 3.2-3.2 1.7 0 3.2 1.5 3.2 3.2 0 1.7-1.4 3.2-3.2 3.2m0-5c-1 0-1.7.8-1.7 1.7 0 1 .8 1.7 1.7 1.7 1 0 1.7-.8 1.7-1.7 0-.9-.7-1.7-1.7-1.7"
  })));
};
export default SvgDescriptiveLocationPin;